import React from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { openTaskInNewTab } from "../../helper/common";
import { icon, label, tooltip } from "../../config";

/**
 * Displays action icons for copying the task URL, opening the task in a new tab, and triggering a linked task popup.
 * @author Muskan Thakur
 */
const TaskIcons = ({ url, taskInfo, copyToClipboard, anchor, setShow, setShowPopup, setHashPopupVisible }) => {
  const { task } = useSelector((state) => state.taskSidebar);

  /**
   * Opens the task in a new browser tab and hides the hash popup.
   * @author Abhishek Dhillon
   */
  const handleOpenInNewTab = () => {
    openTaskInNewTab(taskInfo?.Id);
    setHashPopupVisible(false);
  };

  return (
    <Tooltip position='bottom' parentTitle={true}>
      <div className='task-icons-end' ref={anchor}>
        {(url || taskInfo) && (
          <span
            onClick={copyToClipboard}
            title={tooltip.COPY_TASK_LINK}
            id='copy-hyperlink-btn'
            className='editor-popup-task-icon cursor-pointer d-flex'>
            {icon.COPY_CONTENT}
          </span>
        )}
        <span
          id='editor-popup-hovered-button'
          className='editor-popup-task-icon cursor-pointer d-flex'
          title={tooltip.OPEN_TASK_TITLE}
          onClick={handleOpenInNewTab}>
          {icon.OPEN_IN_NEW}
        </span>
        {taskInfo?.taskKey !== label.DOX_TASK_KEY && (
          <span
            className={`editor-popup-task-icon cursor-pointer d-flex ${task.taskId === taskInfo?.Id ? "disabled" : ""}`}
            title={tooltip.LINK_THIS_TASK}
            onClick={() => {
              if (task.taskId !== taskInfo?.Id) {
                setShowPopup(true);
                setShow(true);
              }
            }}>
           {icon.MEDIATION}
          </span>
        )}
      </div>
    </Tooltip>
  );
};

export default React.memo(TaskIcons);
